import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CarouselComponent } from "./carousel.component";

import { SwiperModule } from "swiper/angular";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [CarouselComponent],
  imports: [CommonModule, SwiperModule, LazyLoadImageModule, RouterModule],
  exports: [CarouselComponent], // Exporta o componente para ser usado em outros módulos
})
export class CarouselComponentModule {}
